import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopeSwitch", "aria-labelledby", "name", "checked", "defaultChecked", "required", "disabled", "value", "onCheckedChange"],
    _excluded2 = ["__scopeSwitch"],
    _excluded3 = ["control", "checked", "bubbles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useLabelContext as e } from "@radix-ui/react-label";
import { Primitive as t } from "@radix-ui/react-primitive";
import { useSize as r } from "@radix-ui/react-use-size";
import { usePrevious as o } from "@radix-ui/react-use-previous";
import { useControllableState as a } from "@radix-ui/react-use-controllable-state";
import { createContextScope as c } from "@radix-ui/react-context";
import { useComposedRefs as i } from "@radix-ui/react-compose-refs";
import { composeEventHandlers as n } from "@radix-ui/primitive";
import * as s from "react";
import d from "@babel/runtime/helpers/esm/extends";

var _c = c("Switch"),
    _c2 = _slicedToArray(_c, 2),
    l = _c2[0],
    u = _c2[1];

export { u as createSwitchScope };

var _l = l("Switch"),
    _l2 = _slicedToArray(_l, 2),
    p = _l2[0],
    m = _l2[1];

export var Switch = /*#__PURE__*/s.forwardRef(function (r, o) {
  var c = r.__scopeSwitch,
      l = r["aria-labelledby"],
      u = r.name,
      m = r.checked,
      f = r.defaultChecked,
      x = r.required,
      k = r.disabled,
      _r$value = r.value,
      w = _r$value === void 0 ? "on" : _r$value,
      v = r.onCheckedChange,
      S = _objectWithoutProperties(r, _excluded),
      _s$useState = s.useState(null),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      y = _s$useState2[0],
      E = _s$useState2[1],
      C = i(o, function (e) {
    return E(e);
  }),
      g = e(y),
      R = l || g,
      T = s.useRef(!1),
      P = !y || Boolean(y.closest("form")),
      _a = a({
    prop: m,
    defaultProp: f,
    onChange: v
  }),
      _a2 = _slicedToArray(_a, 2),
      _a2$ = _a2[0],
      _ = _a2$ === void 0 ? !1 : _a2$,
      q = _a2[1];
  /*#__PURE__*/


  return s.createElement(p, {
    scope: c,
    checked: _,
    disabled: k
  }, /*#__PURE__*/s.createElement(t.button, d({
    type: "button",
    role: "switch",
    "aria-checked": _,
    "aria-labelledby": R,
    "aria-required": x,
    "data-state": h(_),
    "data-disabled": k ? "" : void 0,
    disabled: k,
    value: w
  }, S, {
    ref: C,
    onClick: n(r.onClick, function (e) {
      q(function (e) {
        return !e;
      }), P && (T.current = e.isPropagationStopped(), T.current || e.stopPropagation());
    })
  })), P && /*#__PURE__*/s.createElement(b, {
    control: y,
    bubbles: !T.current,
    name: u,
    value: w,
    checked: _,
    required: x,
    disabled: k,
    style: {
      transform: "translateX(-100%)"
    }
  }));
});
/*#__PURE__*/

export var SwitchThumb = /*#__PURE__*/s.forwardRef(function (e, r) {
  var o = e.__scopeSwitch,
      a = _objectWithoutProperties(e, _excluded2),
      c = m("SwitchThumb", o);
  /*#__PURE__*/


  return s.createElement(t.span, d({
    "data-state": h(c.checked),
    "data-disabled": c.disabled ? "" : void 0
  }, a, {
    ref: r
  }));
});
/*#__PURE__*/

var b = function b(e) {
  var t = e.control,
      a = e.checked,
      _e$bubbles = e.bubbles,
      c = _e$bubbles === void 0 ? !0 : _e$bubbles,
      i = _objectWithoutProperties(e, _excluded3),
      n = s.useRef(null),
      l = o(a),
      u = r(t);

  return s.useEffect(function () {
    var e = n.current,
        t = window.HTMLInputElement.prototype,
        r = Object.getOwnPropertyDescriptor(t, "checked").set;

    if (l !== a && r) {
      var _t = new Event("click", {
        bubbles: c
      });

      r.call(e, a), e.dispatchEvent(_t);
    }
  }, [l, a, c]), /*#__PURE__*/s.createElement("input", d({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: a
  }, i, {
    tabIndex: -1,
    ref: n,
    style: _objectSpread(_objectSpread(_objectSpread({}, e.style), u), {}, {
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    })
  }));
};

function h(e) {
  return e ? "checked" : "unchecked";
}

export var Root = Switch;
export var Thumb = SwitchThumb;